"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_locky_1 = require("react-locky");
var react_style_singleton_1 = require("react-style-singleton");
var utils_1 = require("./utils");
var Style = react_style_singleton_1.styleSinglentone();
var getStyles = function (allowRelative, gapMode, important) { return "\n  body {\n    overflow: hidden " + important + ";\n    " + (allowRelative && "position: relative " + important + ";") + "\n    " + (gapMode == 'margin' && "margin-right: " + utils_1.getGapWidth(gapMode) + "px " + important + ";") + "\n    " + (gapMode == 'padding' && "padding-right: " + utils_1.getGapWidth(gapMode) + "px " + important + ";") + "\n  }\n  \n  .react-scroll-locky-extender {\n    position: absolute;    \n    left: 0;    \n    right: -" + utils_1.getGapWidth(gapMode) + "px;\n  }\n  \n  .react-scroll-locky-edge-right {\n    right: " + utils_1.getGapWidth(gapMode) + "px;\n  }\n  \n  .react-scroll-locky-extender .react-scroll-locky-extender {\n    right: 0;\n  }\n  \n  .react-scroll-locky {\n    -webkit-overflow-scrolling: touch;\n  }\n"; };
var ScrollLocky = (function (_super) {
    __extends(ScrollLocky, _super);
    function ScrollLocky() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollLocky.prototype.render = function () {
        var _a = this.props, _b = _a.enabled, enabled = _b === void 0 ? true : _b, children = _a.children, noRelative = _a.noRelative, _c = _a.gapMode, gapMode = _c === void 0 ? 'margin' : _c, noImportant = _a.noImportant, className = _a.className, headless = _a.headless, onEscape = _a.onEscape;
        return (React.createElement(React.Fragment, null,
            enabled && React.createElement(Style, { styles: getStyles(!noRelative, gapMode, !noImportant ? "!important" : '') }),
            React.createElement(react_locky_1.default, { enabled: !!enabled, className: ("react-scroll-locky " + (className || '')).trim(), leaded: true, group: "react-scroll-locky", headless: headless, onEscape: onEscape }, children)));
    };
    return ScrollLocky;
}(react_1.Component));
exports.ScrollLocky = ScrollLocky;
exports.ScrollLockyPane = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return (React.createElement("div", { className: "react-scroll-locky-extender " + (className || ''), style: style }, children));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-locky/dist/component.js
// module id = 958
// module chunks = 58